export var SportType;
(function (SportType) {
    SportType[SportType["Soccer"] = 1] = "Soccer";
    SportType[SportType["American Football"] = 2] = "American Football";
    SportType[SportType["Hockey"] = 3] = "Hockey";
    SportType[SportType["Rugby"] = 4] = "Rugby";
    SportType[SportType["AFL"] = 5] = "AFL";
    SportType[SportType["Cricket"] = 6] = "Cricket";
    SportType[SportType["Lacrosse"] = 7] = "Lacrosse";
})(SportType || (SportType = {}));
//# sourceMappingURL=sportType.enum.js.map